define('app/models/shipping_address',['app/setup'], function(takhfifan) {
  takhfifan.ShippingAddress = Backbone.Model.extend({

    validation: {
      'shipping[firstname]': {
          required: true,
          msg: i18n.t('first_name_missing')
      },
      'shipping[lastname]': {
          required: true,
          msg: i18n.t('last_name_missing')
      },
      'shipping[street][]': {
          required: true,
          msg: i18n.t('street_missing')
      },
      'shipping[postcode]': {
          required: !takhfifan.isYadisa,
          msg: i18n.t('postcode_missing')
      },
      'shipping[city]': {
          required: true,
          msg: i18n.t('city_missing')
      },
      'shipping[region_id]': function(value, attr, computedState) {
        if (-1 == _.indexOf(
          this.get('availableRegionCodes'), parseInt(value)
        )) {
          return i18n.t('region_missing');
        }
      },
      'shipping[telephone]': {
          required: true,
          msg: i18n.t('telephone_missing')
      }
    },

    save: function() {
      var _this = this;
      var json = this.toJSON();

      // remove attributes that are for JS app only
      delete json.isActive;
      delete json.regionName;
      delete json.availableRegionCodes;

      $.post(this.get('saveUrl'), json).done(function(data){
        if (!_.isNull(data)) {
          if (typeof data == 'string') {
            data = JSON.parse(data);
          }
          if (!_.isNull(data.error) && data.error == 1) {
            takhfifan.eventHub.trigger('shipping:error', data.message);
          } else {
            var addressId = _this.get('shipping_address_id');
            if (_.isUndefined(addressId) || _.isNull(addressId)) {
              _this.set('shipping_address_id', data.address_id, {silent: true});
            }
            takhfifan.eventHub.trigger('shipping:updated', _this);
            takhfifan.eventHub.trigger('shipping:method_updated', data);
            takhfifan.eventHub.trigger('shipping:total_updated', data.grand_total);
            takhfifan.eventHub.trigger('shipping:addressSaved', _this.toJSON());
          }
        }
      }).fail(function(data){
        takhfifan.eventHub.trigger(
          'shipping:error', [i18n.t('connection_error')]
        );
      });
    },

    clearFormData: function() {
      this.unset('shipping_address_id', {silent: true});
      this.set({
        'shipping[firstname]': null,
        'shipping[lastname]': null,
        'shipping[street][]': null,
        'shipping[postcode]': null,
        'shipping[city]': null,
        'shipping[region_id]': null,
        'shipping[telephone]': null
      });
    },

    loadFormData: function(data) {
      this.set({
        'shipping_address_id': data.addressId,
        'regionName': data.regionName,
        'shipping[firstname]': data.firstname,
        'shipping[lastname]': data.lastname,
        'shipping[street][]': data.street,
        'shipping[postcode]': data.postcode,
        'shipping[city]': data.city,
        'shipping[region_id]': data.regionId,
        'shipping[country_id]': data.countryId,
        'shipping[telephone]': data.telephone
      });
    },

    defaults: {
      default_billing: 1,
      default_shipping: 1,
      'shipping[country_id]': 'IR',
      'shipping[save_in_address_book]': 1,
      'shipping[use_for_shipping]': 1
    }

  });

});

